export enum AssessmentStatusEnum {
    New = 0,
    InProgress = 1,
    Finished = 2
}